import { useEffect, useRef } from 'react'
import { countryBounds, requestedCountry } from '../../utils/countryFocus'

// « Voir sur la carte » depuis l'annuaire (PP-43) : ?country=<id> cadre le pays
// et trace ses frontières en or. Un calque à lui plutôt que l'isolement de la
// légende, que la légende remet à zéro quand elle se monte.
export function useFocusCountry(map, regionsData) {
  const done = useRef(false)

  useEffect(() => {
    if (done.current || !map.current || !regionsData) return
    const id = requestedCountry(window.location.search)
    if (!id) {
      done.current = true
      return
    }
    const apply = () => {
      // Les régions peuvent arriver avant leur source : on réessaie quand la
      // carte a fini de charger, une fois.
      if (done.current || !map.current || !map.current.getSource('regions')) return false
      done.current = true
      const bounds = countryBounds(regionsData, id)
      if (!bounds) return true
      if (!map.current.getLayer('country-focus')) {
        map.current.addLayer({
          id: 'country-focus',
          type: 'line',
          source: 'regions',
          filter: ['==', ['get', 'country_id'], id],
          paint: { 'line-color': '#D5B654', 'line-width': 3 },
        })
      }
      map.current.fitBounds([[bounds[0], bounds[1]], [bounds[2], bounds[3]]],
        { padding: 60, maxZoom: 7, duration: 1500 })
      return true
    }
    if (!apply()) map.current.once('idle', apply)
  }, [map, regionsData])
}
